<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/task/cron/log/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('tuisongshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select size="mini" v-model="yt.conditions.status" :placeholder="$t('qingxuanze')" clearable>
              <el-option :key="0" :label="$t('shibai')" :value="0"> </el-option>
              <el-option :key="1" :label="$t('chenggong')" :value="1"> </el-option>
              <el-option :key="2" :label="$t('jinxingzhong')" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL></template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button> -->
      </template>
      <template #zhuangtai="scope">
        <div v-if="scope.row.status != null">
          <el-tag v-if="scope.row.status === 0" type="danger">{{ $t('shibai') }}</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success">{{ $t('chenggong') }}</el-tag>
          <el-tag v-if="scope.row.status === 2" type="info">{{ $t('jinxingzhong') }}</el-tag>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
import dayjs from 'dayjs';

export default {
  name: 'web_system_task_cron_log',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      conditions: {
        createTimeStart: dayjs().startOf('month').valueOf(),
        createTimeEnd: dayjs().valueOf(),
        name: this.name
      },
      columns: [
        {
          label: 'tuisongyonghu',
          prop: 'pushUser.nickname'
        },
        {
          label: 'tuisongshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'tuisongfangshi',
          prop: 'pushWay',
          type: 'dictionary',
          key: 'TASK_CRON_PUSH_WAY'
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
  }
};
</script>
